import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLightbulbDim = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 246 246",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M172.663 138.135c-7.611 10.417-15.26 20.91-18.911 33.133h-61.5c-3.69-12.261-11.34-22.716-18.912-33.133-1.998-2.729-3.997-5.458-5.919-8.226-7.61-10.954-12.07-24.254-12.07-38.59 0-37.362 30.29-67.651 67.651-67.651s67.65 30.289 67.65 67.65c0 14.337-4.459 27.637-12.07 38.553-1.921 2.767-3.92 5.497-5.919 8.226v.038Zm-18.911 51.583c0 16.99-13.761 30.75-30.75 30.75-16.99 0-30.75-13.76-30.75-30.75v-6.15h61.5v6.15Zm-30.75-129.15c3.382 0 6.15-2.767 6.15-6.15 0-3.383-2.768-6.15-6.15-6.15-23.793 0-43.05 19.257-43.05 43.05 0 3.383 2.767 6.15 6.15 6.15 3.382 0 6.15-2.767 6.15-6.15 0-16.99 13.76-30.75 30.75-30.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			style: { opacity: .3 },
			d: "m26.637 25.206 18.45 12.3c4.228 2.844 5.381 8.571 2.576 12.8-2.806 4.228-8.572 5.38-12.8 2.575l-18.45-12.3c-4.228-2.845-5.381-8.572-2.575-12.8 2.806-4.228 8.571-5.381 12.8-2.575ZM229.588 40.58l-18.45 12.3c-4.229 2.844-9.956 1.691-12.8-2.575-2.844-4.267-1.691-9.956 2.575-12.8l18.45-12.3c4.228-2.845 9.956-1.691 12.8 2.575 2.844 4.267 1.691 9.955-2.575 12.8ZM9.225 85.168h24.6a9.203 9.203 0 0 1 9.225 9.225 9.203 9.203 0 0 1-9.225 9.225h-24.6A9.203 9.203 0 0 1 0 94.393a9.203 9.203 0 0 1 9.225-9.225Zm202.95 0h24.6A9.202 9.202 0 0 1 246 94.393a9.202 9.202 0 0 1-9.225 9.225h-24.6a9.203 9.203 0 0 1-9.225-9.225 9.203 9.203 0 0 1 9.225-9.225ZM45.087 151.281l-18.45 12.3c-4.228 2.844-9.955 1.691-12.8-2.575-2.844-4.267-1.69-9.956 2.576-12.8l18.45-12.3c4.228-2.844 9.955-1.691 12.8 2.575 2.844 4.267 1.69 9.956-2.576 12.8Zm166.051-15.337 18.45 12.3c4.228 2.845 5.381 8.572 2.575 12.8-2.806 4.228-8.572 5.381-12.8 2.576l-18.45-12.301c-4.228-2.844-5.381-8.571-2.575-12.799s8.571-5.381 12.8-2.576Z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 .605h246v246H0z"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "b",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 23.668h246v196.8H0z"
			})
		})] })
	]
});
export default SvgIconLightbulbDim;
